import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { InsuranceService } from '../../../../../services/insurance.service';
import { MenuItem, TreeNode } from 'primeng/api';

import { MessageService } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import { Claim, Attachment } from '../../models/claim.models';
import { HelpersService } from '../../../../../services/helpers.service';

import { Bike, BikeComponent } from '../../models/claim.models';

//import { BikeComponent } from '../../../../shared/bike/bike.component';

interface Insurer {
  ID: number;
  Name: string;
}

@Component({
  selector: 'app-create-claim',
  templateUrl: './create-claim.component.html',
  styleUrls: ['./create-claim.component.scss', '../../css/_shared.scss'],
  providers: [MessageService],
  encapsulation: ViewEncapsulation.None,
})
export class CreateClaimComponent implements OnInit {
  claimID: number = 0;
  uploadedFiles: any[] = [];
  claimFiles: Attachment[] = [];

  files: TreeNode[];
  bikes: string[] = [];
  components: string[] = [];

  bikeObjects: Bike[] = [];

  bikeSelectList: SelectItem[] = [];
  bikeSelected: Bike;

  policyNumber: string = '';
  claimNumber: string = '';
  excess: number = 0;
  sumInsured: number = 0;

  insurer: string = '';
  agentName: string = '';
  agenteMail: string = '';
  agentPhone: string = '';

  insuredName: string = '';
  insuredeMail: string = '';
  insuredPhone: string = '';

  itemDetails: string = '';
  incidentDetails: string = '';
  incidentDate: Date;

  claimObject: Claim;

  insurers: SelectItem[] = [];
  selectedInsurer: Insurer;

  incidentTypes: SelectItem[] = [];
  selectedIncidentType: any;
  incidentLocation: any;

  isSaving: boolean = false;
  bikeAdded: boolean = false;

  documentLink: string = '';

  constructor(
    public insuranceService: InsuranceService,
    public messageService: MessageService,
    public helpersService: HelpersService,
  ) {}

  ngOnInit() {
    this.insurers = [{ label: 'Select Insurer', value: null }];

    this.incidentTypes = [
      { label: 'Select Incident Type', value: null },
      { label: 'Accidental damage', value: { label: 'Accidental damage' } },
      { label: 'Theft from home', value: { label: 'Theft from home' } },
      {
        label: 'Theft away from home',
        value: { label: 'Theft away from home' },
      },
    ];

    this.bikeSelectList = [];
    this.bikes = [];
    this.components = [];
    this.bikeObjects = [];

    this.insuranceService.getInsurers().subscribe((response) => {
      console.log(response);
      var obj = JSON.parse(response);
      for (var i = 0; i < obj.Insurers.length; i++) {
        if (this.helpersService.getProfileInsuranceRoles().insurerID > 0) {
          if (
            this.helpersService.getProfileInsuranceRoles().insurerID ==
            obj.Insurers[i].ID
          ) {
            this.insurers.push({
              label: obj.Insurers[i].Name,
              value: { ID: obj.Insurers[i].ID },
            });
            this.selectedInsurer = obj.Insurers[i];
            this.agentName =
              this.helpersService.getProfileData().Name +
              ' ' +
              this.helpersService.getProfileData().Surname;
            this.agenteMail = this.helpersService.getProfileData().Email;
            this.agentPhone = this.helpersService.getProfileData().PhoneNumber;
          }
        } else {
          this.insurers.push({
            label: obj.Insurers[i].Name,
            value: { ID: obj.Insurers[i].ID },
          });
        }
      }
    });

    this.files = [
      {
        label: 'Documents',
        data: 'Backup Folder',
        expandedIcon: 'pi pi-folder-open',
        collapsedIcon: 'pi pi-folder',
      },
      {
        label: 'Images',
        data: 'Backup Folder',
        expandedIcon: 'pi pi-folder-open',
        collapsedIcon: 'pi pi-folder',
      },
    ];
  }

  newClaim() {
    this.isSaving = false;
    this.claimID = 0;
    console.log(this.bikeObjects);

    this.files = [
      {
        label: 'Documents',
        data: 'Backup Folder',
        expandedIcon: 'pi pi-folder-open',
        collapsedIcon: 'pi pi-folder',
      },
      {
        label: 'Images',
        data: 'Backup Folder',
        expandedIcon: 'pi pi-folder-open',
        collapsedIcon: 'pi pi-folder',
      },
    ];

    this.policyNumber = '';
    this.claimNumber = '';

    this.insurer = '';

    this.agentName = '';
    this.agenteMail = '';
    this.agentPhone = '';

    this.insuredName = '';
    this.insuredeMail = '';
    this.insuredPhone = '';

    this.itemDetails = '';
    this.incidentDate = new Date();
    this.incidentDetails = '';
    this.bikeObjects = [];
    this.components = [];
    this.bikeSelected = null;

    this.excess = 0;
    this.sumInsured = 0;
    this.selectedIncidentType = {};
    this.incidentLocation = '';
    this.selectedInsurer = { ID: 0, Name: '' };
    this.bikes = [];
    this.bikeSelectList = [];
  }

  saveClaim() {
    this.isSaving = true;
    let re = /'/gi;
    if (this.incidentDetails !== undefined)
      this.incidentDetails = this.incidentDetails.replace(re, '`');
    if (this.incidentLocation !== undefined)
      this.incidentLocation = this.incidentLocation.replace(re, '`');

    if (this.agentName !== undefined)
      this.agentName = this.agentName.replace(re, '`');
    if (this.insuredName !== undefined)
      this.insuredName = this.insuredName.replace(re, '`');

    var count = 0;
    var arrC = 0;
    for (var i = 0; i < this.uploadedFiles.length; i++) {
      var reader = new FileReader();
      reader.readAsDataURL(this.uploadedFiles[i]);
      reader.onload = (file: any) => {
        let data = {
          ID: 0,
          ClaimID: 0,
          FileType: this.uploadedFiles[arrC].type,
          FileName: this.uploadedFiles[arrC].name,
          FileURL: '',
          FileData: file.target.result.split(',')[1],
        };

        if (this.claimFiles.indexOf(data) === -1) this.claimFiles.push(data);

        count += 1;
        arrC += 1;

        var incidentType = '';
        if (this.selectedIncidentType != undefined)
          incidentType = this.selectedIncidentType.label;

        if (count == this.uploadedFiles.length) {
          if (this.uploadedFiles.length == this.claimFiles.length) {
            this.claimObject = new Claim(
              this.claimID,
              this.selectedInsurer.ID,
              this.policyNumber,
              this.claimNumber,
              1,
              '',
              this.helpersService.getUserId(),
              '',
              0,
              0,
              this.itemDetails,
              this.sumInsured,
              this.excess,
              this.incidentDate,
              this.incidentDetails,
              this.selectedInsurer.Name,
              this.agentName,
              this.agenteMail,
              this.agentPhone,
              this.insuredName,
              this.insuredeMail,
              this.insuredPhone,
              this.bikeObjects,
              [],
              '',
              '',
              incidentType,
              '',
              this.incidentLocation,
              this.claimFiles,
              '',
            );

            this.insuranceService
              .saveClaim(this.claimObject)
              .subscribe((response) => {
                var obj = JSON.parse(response);
                console.log(obj);
                for (var i = 0; i < obj.Claims.length; i++) {
                  if (obj.Claims[i].ID > 0) {
                    this.messageService.add({
                      life: 5000,
                      summary: 'Claim saved',
                      detail:
                        'Claim has been saved. Continue editing the claim or create a new one',
                    });
                    this.claimObject = obj.Claims[i];
                    this.claimID = this.claimObject.ID;
                    this.isSaving = false;
                  }
                }
              });
          }
        }
      };
    }

    if (this.uploadedFiles.length == 0) {
      var incidentType = '';
      if (this.selectedIncidentType != undefined)
        incidentType = this.selectedIncidentType.label;

      console.log('UserID: ', this.helpersService.getUserId());

      this.claimObject = new Claim(
        this.claimID,
        this.selectedInsurer.ID,
        this.policyNumber,
        this.claimNumber,
        1,
        '',
        this.helpersService.getUserId(),
        '',
        0,
        0,
        this.itemDetails,
        this.sumInsured,
        this.excess,
        this.incidentDate,
        this.incidentDetails,
        this.selectedInsurer.Name,
        this.agentName,
        this.agenteMail,
        this.agentPhone,
        this.insuredName,
        this.insuredeMail,
        this.insuredPhone,
        this.bikeObjects,
        [],
        '',
        '',
        incidentType,
        '',
        this.incidentLocation,
        [],
        this.documentLink,
      );

      console.log(this.claimObject);

      this.insuranceService.saveClaim(this.claimObject).subscribe(
        (response) => {
          var obj = JSON.parse(response);
          console.log(obj);
          for (var i = 0; i < obj.Claims.length; i++) {
            if (obj.Claims[i].ID > 0) {
              this.messageService.add({
                life: 5000,
                summary: 'Claim saved',
                detail:
                  'Claim has been saved. Continue editing the claim or create a new one',
              });
              this.claimObject = obj.Claims[i];
              this.claimID = this.claimObject.ID;
              this.isSaving = false;
            }
          }
        },
        (err) => {
          console.log(err);
          this.messageService.add({
            life: 5000,
            summary: 'Claim not saved',
            detail: 'Claim failed to save: ' + err,
          });
          this.isSaving = false;
        },
      );
    }
  }

  addBike(event) {
    if (event.value !== undefined) {
      if (this.bikeObjects == undefined) {
        this.bikeObjects = [];
      }
      if (this.bikeSelectList == undefined) {
        this.bikeSelectList = [];
      }

      let re = /'/gi;
      event.value = event.value.replace(re, '`');

      this.bikeAdded = true;
      this.bikeSelectList.push({ label: event.value, value: event.value });
      this.bikeObjects.push({
        ID: 0,
        Name: event.value,
        Components: [],
        Excess: 0,
        SumInsured: 0,
      });
    }
  }

  addComponentToBike(event) {
    if (this.bikeSelected == undefined) this.bikeSelected = this.bikeObjects[0];

    let re = /'/gi;
    event.value = event.value.replace(re, '`');

    for (var i = 0; i < this.bikeObjects.length; i++) {
      if (this.bikeObjects[i].Name === this.bikeSelected.toString()) {
        this.bikeObjects[i].Components.push({
          ID: 0,
          Description: event.value,
        });
      }
    }
  }

  addExcessToBike() {
    console.log(this.bikeSelected);
    if (this.bikeSelected == undefined) this.bikeSelected = this.bikeObjects[0];

    for (var i = 0; i < this.bikeObjects.length; i++) {
      if (this.bikeObjects[i].Name === this.bikeSelected.toString()) {
        this.bikeObjects[i].Excess = this.excess;
      }
    }
  }

  addSumInsuredToBike() {
    console.log(this.bikeSelected);
    if (this.bikeSelected == undefined) this.bikeSelected = this.bikeObjects[0];

    for (var i = 0; i < this.bikeObjects.length; i++) {
      if (this.bikeObjects[i].Name === this.bikeSelected.toString()) {
        this.bikeObjects[i].SumInsured = this.sumInsured;
      }
    }
  }

  removeBike(event) {
    for (var i = 0; i < this.bikeSelectList.length; i++) {
      if (this.bikeSelectList[i].label === event.value) {
        this.bikeSelectList.splice(i, 1);
        i--;
      }
    }

    for (var i = 0; i < this.bikeObjects.length; i++) {
      if (this.bikeObjects[i].Name === event.value) {
        this.bikeObjects.splice(i, 1);
        i--;
      }
    }

    if (this.bikeSelectList.length == 0) {
      this.bikeAdded = false;
    }

    console.log(this.bikeSelectList);
  }

  removeComponentToBike(event) {
    for (var i = 0; i < this.bikeObjects.length; i++) {
      if (this.bikeObjects[i].Name === this.bikeSelected.toString()) {
        for (var x = 0; x < this.bikeObjects[i].Components.length; x++) {
          if (this.bikeObjects[i].Components[x] === event.value) {
            this.bikeObjects[i].Components.splice(x, 1);
            x--;
          }
        }
      }
    }
  }

  showComponents() {
    console.log(this.bikeSelected);
    this.components = [];
    this.excess = 0;
    this.sumInsured = 0;
    for (var i = 0; i < this.bikeObjects.length; i++) {
      if (this.bikeObjects[i].Name === this.bikeSelected.toString()) {
        for (var x = 0; x < this.bikeObjects[i].Components.length; x++) {
          this.components.push(this.bikeObjects[i].Components[x].Description);
        }
        this.excess = this.bikeObjects[i].Excess;
        this.sumInsured = this.bikeObjects[i].SumInsured;
      }
    }
  }

  onUpload(event) {
    var cont = true;
    console.log(event);
    for (let file of event.files) {
      if (this.uploadedFiles.indexOf(file) === -1)
        this.uploadedFiles.push(file);
    }
  }

  onRemove(event) {
    this.uploadedFiles.splice(this.uploadedFiles.indexOf(event.file), 1);
  }

  autoAddBike(event) {
    var bike = event.target.value;

    if (bike !== '') {
      if (this.bikeObjects == undefined) {
        this.bikeObjects = [];
      }
      if (this.bikeSelectList == undefined) {
        this.bikeSelectList = [];
      }

      let re = /'/gi;
      bike = bike.replace(re, '`');

      this.bikeAdded = true;
      this.bikeSelectList.push({ label: bike, value: bike });
      this.bikeObjects.push({
        ID: 0,
        Name: bike,
        Components: [],
        Excess: 0,
        SumInsured: 0,
      });
    }
  }
}







